// Resolve the initial location for a booking flow. Returns '' when the driver
// has no usable preferred location, so the flow starts with nothing selected
// and the driver must pick one. `normalize` lets the entitlement flow map a
// stored value to a venue key; the credit flow omits it and uses the value as-is.
export function resolvePreferredLocation(
  preferred: string | null | undefined,
  isValid: (candidate: string) => boolean,
  normalize?: (raw: string) => string,
): string {
  if (!preferred) return '';
  const candidate = normalize ? normalize(preferred) : preferred;
  return isValid(candidate) ? candidate : '';
}

// Persist the booked venue as the driver's preference, but only when they have
// none yet. Swallows all errors — the booking has already succeeded and the
// preference is a nice-to-have, never worth surfacing or failing over.
export async function savePreferredLocationIfEmpty(
  currentPreferred: string | null | undefined,
  bookedLocation: string,
  patch: (loc: string) => Promise<void>,
  refresh: () => Promise<unknown>,
): Promise<void> {
  if (currentPreferred) return;
  try {
    await patch(bookedLocation);
    await refresh();
  } catch {
    // Intentionally ignored: booking succeeded; preference save is best-effort.
  }
}
